/**
 * Project case study — back link remembers service page via sessionStorage.
 * Key: ode-work-return { href, label }
 */
(function () {
  function initBackLinks() {
    var root = document.querySelector('[data-ode-case]');
    if (!root) return;

    var links = root.querySelectorAll('[data-case-back]');
    if (!links.length) return;

    var fallbackHref = root.getAttribute('data-case-back-fallback') || '/pages/studio-work';
    var fallbackLabel = root.getAttribute('data-case-back-fallback-label') || '← Back to Studio/Work';
    var href = fallbackHref;
    var label = fallbackLabel;

    try {
      var stored = JSON.parse(sessionStorage.getItem('ode-work-return') || 'null');
      if (stored && stored.href) {
        href = stored.href;
        if (stored.label) label = stored.label;
      }
    } catch (e) {
      /* ignore */
    }

    links.forEach(function (link) {
      link.setAttribute('href', href);
      link.textContent = label;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackLinks);
  } else {
    initBackLinks();
  }
})();
